import React, { useState, useRef, useEffect } from 'react';
import { Button, Input, Col, Row, Result, Spin } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';

// 浏览器
const Browser = (props) => {
  const inputRef = useRef();
  const [ result, setResult ] = useState(null);
  const [ loading, setLoading ] = useState(null);

  const { style, device } = props;

  const onEnter = async() => {
    setLoading(true);

    let urlText = inputRef.current.input.value;

    // 确定主机是否能够通信
    try {
      const response = await device.HTTP_get(urlText);
      setResult({
        status: 'success',
        title: response.title,
      });
    }
    catch(e) {
      setResult({
        status: e.status,
        title: e.title,
        subTitle: e.subTitle
      });
    }
    
    setLoading(false);
  };

  useEffect(() => {
    inputRef.current.focus();
    inputRef.current.select();
  });

  return (
    <div style={style}>
      <Row>
          <Col span={20}><Input ref={inputRef} defaultValue="https://www.iyopu.com/" style={{border: '3px solid #60AFFF', height: '44px', borderRadius: '11px'}} onKeyDown={(e) => { if(e.which === 13) { onEnter() } }}></Input></Col>
          <Col offset={1} span={3}><Button type="primary" onClick={onEnter} style={{
            width: '80%',
            height: '44px', 
            background: '#1B6FED',
            border: '3px solid #60AFFF',
            borderRadius: '11px',
            color: '#FFFFFF',
          }}
            icon={<CaretRightOutlined />}
          /></Col>
      </Row>
      {
        loading ? (
          <div style={{ textAlign: 'center', width: '100%', marginTop: 50 }}><Spin size="large" tip={`正在为您加载...`} /></div>
        ): (
          result ? (
            <>
              <Result
                status={result.status}
                title={result.title}
                subTitle={result.subTitle}
              />
            </>
          ): null
        )

      }
    </div>
  )
}

export default Browser;
  